const PropTypes = require('prop-types');
/**
 * Created by adderlyjaureguicampos on 08/12/16.
 */
const React = require("react");

const { formatText } = require('core/i18n').i18n;
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');

class ThirdPartyTransitionalFunds extends React.Component {


    constructor(props) {
        super(props);
        this.buildRadioGroup = this.buildRadioGroup.bind(this);
    }


    buildRadioButton(radioButton) {
        return (<RadioButton
            label={radioButton.label}
            value={radioButton.value}
            className="block-step__radio"/>);
    }

    buildRadioGroup(radioOptions) {
        return (
            <RadioButtonGroup
                name="thirdPartyTransitionalFunds"
                idPrefix="thirdPartyTransitionalFundsSelected"
                selectedValue={this.props.selectedValue}
                className="block-step__radio-group"
                onChange={this.props.handleRadioButtonChange}>
                {radioOptions}
            </RadioButtonGroup>
        );
    }

    render() {
        let radioOptions = [];
        this.props.radioOptions.forEach( option => {
            radioOptions.push(this.buildRadioButton(option));
        });
        switch (this.props.type) {
            case 'single':
                return (
                    <div className="tax-data">
                        <div className="ok-slider__text">{formatText('contractsView-checkingAccountThirdPartyFirstRadioGroupTitle')}</div>
                        {this.buildRadioGroup(radioOptions)}
                    </div>);
            case 'form':
                return (
                    <div className="tax-data">
                        <div className="ok-slider__text">{formatText('contractsView-checkingAccountThirdPartySecondRadioGroupTitle')}</div>
                        <div className="ok-slider__slider-box">
                            {this.buildRadioGroup(radioOptions)}
                        </div>
                    </div>
                )
        }
    }
}

ThirdPartyTransitionalFunds.propTypes = {
    handleRadioButtonChange: PropTypes.func,
    type: PropTypes.string,
    radioOptions: PropTypes.array,
    selectedValue: PropTypes.number
};


module.exports = ThirdPartyTransitionalFunds;